import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import dayjs from 'dayjs'
import TianyanchaRecordCard from '../TianyanchaRecordCard'

interface DishonestItem {
  casecode: string
  disrupttypename: string
  reason: string
  courtname: string
  areaname: string
  regdate: number
  publishdate: number
  performance: string
  duty: string
}

interface Props {
  data: any
  title: string
  sectionIndex?: string
}

const normalizeItems = (items: DishonestItem[] = []) =>
  items.map((item) => ({
    caseNo: item.casecode || '—',
    type: item.disrupttypename || '—',
    reason: item.reason || '—',
    court: `${item.areaname || ''} ${item.courtname || ''}`.trim(),
    regDate: item.regdate ? dayjs(item.regdate).format('YYYY-MM-DD') : '—',
    publishDate: item.publishdate ? dayjs(item.publishdate).format('YYYY-MM-DD') : '—',
    performance: item.performance || '—',
    duty: item.duty?.trim() || '—',
  }))

export default function TianyanchaDishonest({ data, title, sectionIndex }: Props) {
  let jsonData: any = {}
  try {
    jsonData = JSON.parse(data.tianyancha_dishonest ?? '{}')
  } catch (error) {
    jsonData = {}
  }

  const dishonests = normalizeItems(jsonData.items)
  const theme = useTheme()

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          失信被执行信息
        </Text>
        <Stack gap="sm" className="mt-3">
          {dishonests.length === 0 ? (
            <Text c="dimmed" size="sm" ta="center">
              暂无失信被执行信息
            </Text>
          ) : (
            dishonests.map((item, index) => (
              <TianyanchaRecordCard
                key={`${item.caseNo}-${index}`}
                number={index + 1}
                recordType="失信记录"
                fields={[
                  { label: '案号', value: item.caseNo },
                  { label: '失信类型', value: item.type, highlight: true },
                  { label: '执行法院', value: item.court },
                  { label: '立案日期', value: item.regDate },
                  { label: '发布日期', value: item.publishDate },
                  { label: '履行情况', value: item.performance },
                  { label: '主要义务', value: item.duty, span: 2 },
                ]}
              />
            ))
          )}
        </Stack>
      </div>
    </ReportWrapper>
  )
}
